import { ApiCore } from '@/services/api/utils/core.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'
import { apiProvider } from '@/services/api/utils/provider.js'

const url = `enrolments`
const plural = 'enrolments'
const single = 'enrolment'

const api = new ApiCore({
	index: true,
    findOne: false,
    findAll: true,
	create: true,
	update: true,
	remove: true,
	url: url,
	plural: plural,
	single: single
})

api.delete = (resource) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}/${resource}`)
		.then(handleResponse)
		.catch(handleError);
}

api.put = (enrollmentId,params) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${enrollmentId}/principals`, params)
		.then(handleResponse)
		.catch(handleError);
}

api.getEnrolmentPrincipals = (enrolmentId) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${enrolmentId}/principals`)
		.then(handleResponse)
		.catch(handleError);
}

api.checkAgentEnrolmentExist = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/agent-enrolment-exists`, params)
		.then(handleResponse)
		.catch(handleError);
}

export default api
